import Languages from '@/modules/corporate/modules/course/views/CourseBuilder/components/SidebarDetails/Settings/components/Dialogs/components/Languages';
import PointsAndBadges from '@/modules/corporate/modules/course/views/CourseBuilder/components/SidebarDetails/Settings/components/Dialogs/components/PointsAndBadges';

import Assign from './Dialogs/Assign';
import AssignmentRestriction from './Dialogs/AssignmentRestriction';
import AttachCategories from './Dialogs/AttachCategories';
import AttachMindsetsGoalsSkillsInArticle from './Dialogs/AttachMindsetsGoalsSkillsInArticle';
import Author from './Dialogs/Author';
import RevertChanges from './Dialogs/RevertChanges';
import Tags from './Dialogs/Tags';
import VersionHistory from './Dialogs/VersionHistory';
import VisibilitySettings from './Dialogs/VisibilitySettings';
import WorkspaceSettings from './Dialogs/WorkspaceSettings';
import { Dialogs } from './types';

const settingsDialogs = {
  [Dialogs.AttachMGS]: AttachMindsetsGoalsSkillsInArticle,
  [Dialogs.Author]: Author,
  [Dialogs.VisibilitySettings]: VisibilitySettings,
  [Dialogs.Tags]: Tags,
  [Dialogs.RevertChanges]: RevertChanges,
  [Dialogs.VersionHistory]: VersionHistory,
  [Dialogs.WorkspaceSettings]: WorkspaceSettings,
  [Dialogs.AssignmentRestriction]: AssignmentRestriction,
  [Dialogs.AttachCategories]: AttachCategories,
  [Dialogs.Assign]: Assign,
  [Dialogs.Languages]: Languages,
  [Dialogs.PointsAndBadges]: PointsAndBadges,
};

export default settingsDialogs;
